/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OAuthScopes } from './OAuthScopes';
import {
    OAuthScopesFromJSON,
    OAuthScopesFromJSONTyped,
    OAuthScopesToJSON,
    OAuthScopesToJSONTyped,
} from './OAuthScopes';

/**
 * 
 * @export
 * @interface CreateOAuthClientBody
 */
export interface CreateOAuthClientBody {
    /**
     * 
     * @type {string}
     * @memberof CreateOAuthClientBody
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOAuthClientBody
     */
    logo?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateOAuthClientBody
     */
    redirectUris: Array<string>;
    /**
     * 
     * @type {Array<OAuthScopes>}
     * @memberof CreateOAuthClientBody
     */
    scopes?: Array<OAuthScopes>;
}

/**
 * Check if a given object implements the CreateOAuthClientBody interface.
 */
export function instanceOfCreateOAuthClientBody(value: object): value is CreateOAuthClientBody {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('redirectUris' in value) || value['redirectUris'] === undefined) return false;
    return true;
}

export function CreateOAuthClientBodyFromJSON(json: any): CreateOAuthClientBody {
    return CreateOAuthClientBodyFromJSONTyped(json, false);
}

export function CreateOAuthClientBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOAuthClientBody {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'logo': json['logo'] == null ? undefined : json['logo'],
        'redirectUris': json['redirectUris'],
        'scopes': json['scopes'] == null ? undefined : ((json['scopes'] as Array<any>).map(OAuthScopesFromJSON)),
    };
}

export function CreateOAuthClientBodyToJSON(json: any): CreateOAuthClientBody {
    return CreateOAuthClientBodyToJSONTyped(json, false);
}

export function CreateOAuthClientBodyToJSONTyped(value?: CreateOAuthClientBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'logo': value['logo'],
        'redirectUris': value['redirectUris'],
        'scopes': value['scopes'] == null ? undefined : ((value['scopes'] as Array<any>).map(OAuthScopesToJSON)),
    };
}

